module.exports = __webpack_public_path__ + "img/pr-1.f075f887.png";